import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const Privacy_PolicyReadSlice = createSlice({
  name: "Privacy_PolicyReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    Privacy_PolicyRead: (state) => {
      state.isLoading = true;
    },
    successPrivacy_PolicyRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurePrivacy_PolicyRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearPrivacy_PolicyRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  Privacy_PolicyRead,
  failurePrivacy_PolicyRead,
  successPrivacy_PolicyRead,
  clearPrivacy_PolicyRead,
} = Privacy_PolicyReadSlice.actions;

export default Privacy_PolicyReadSlice.reducer;
